import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import AllUsers from "../../Pages/Admin/AllUsers";
import RecoveryCompany from "../../Pages/Admin/RecoveryCompany";
import TheftHistory from "../../Pages/Admin/TheftHistory";
import APIAccounts from "../../Pages/Admin/APIAccounts";
import AddNewUser from "../../Pages/Admin/AddNewUser";
import AddRecoveryCompany from "../../Pages/Admin/AddRecoveryCompany";
import AddAPI from "../../Pages/Admin/AddAPI";
import ViewUserDetails from "../../Pages/Admin/ViewUserDetails";
import ViewAPIDetails from "../../Pages/Admin/ViewAPIDetails";
import Notifications from "../../Pages/User/Notifications";
import ViewCustomerDetails from "../../Pages/User/ViewCustomerDetails";
import ViewRecoveryCompanyDetail from "../../Pages/Admin/ViewRecoveryCompanyDetail";
import Settings from "../../Pages/Admin/Settings";
import SystemConfiguration from "../../Pages/Admin/SystemConfiguration";

const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="/all-users" element={<AllUsers />} />
      <Route path="/add-user" element={<AddNewUser />} />
      <Route path="/view-user-details/:id" element={<ViewUserDetails />} />
      <Route path="/recovery-company" element={<RecoveryCompany />} />
      <Route
        path="/view-recovery-company/:id"
        element={<ViewRecoveryCompanyDetail />}
      />
      <Route path="/add-recovery-company" element={<AddRecoveryCompany />} />
      <Route path="/view-customer-details" element={<ViewCustomerDetails />} />
      {/* <Route path="/theft-history" element={<TheftHistory />} /> */}
      <Route path="/api-accounts" element={<APIAccounts />} />
      <Route path="/add-api-accounts" element={<AddAPI />} />
      <Route path="/view-api-details/:id" element={<ViewAPIDetails />} />
      <Route path="/system-configuration" element={<SystemConfiguration />} />
      <Route path="/notifications" element={<Notifications />} />
      <Route path="/settings" element={<Settings />} />

      <Route path="*" element={<Navigate to="/all-users" />} />
    </Routes>
  );
};

export default AdminRoutes;
